<template>
  <v-card flat rounded="lg">
    <v-card-title class="subtitle-1 font-weight-bold"
      >Dados Residenciais</v-card-title
    >
    <v-card-text>
      <v-form ref="form">
        <v-row>
          <v-col xl="2" lg="2" md="2" cols="12">
            <cmb-estados :disabled="editar" />
          </v-col>
          <v-col xl="5" lg="5" md="5" cols="12">
            <cmb-municipios :disabled="editar" />
          </v-col>
          <v-col xl="5" lg="5" md="5" cols="12">
            <cmb-localidades :disabled="editar" />
          </v-col>
          <v-col xl="5" lg="5" md="5" cols="12">
            <v-text-field
              label="Endereço"
              v-model="clienteManut.endereco"
              :disabled="editar"
            ></v-text-field>
          </v-col>
          <v-col xl="1" lg="1" md="1" cols="12">
            <v-text-field
              label="Nº"
              v-model="clienteManut.nroend"
              v-mask="'######'"
              :disabled="editar"
            ></v-text-field>
          </v-col>
          <v-col xl="4" lg="4" md="4" cols="12">
            <v-text-field
              label="Bairro"
              v-model="clienteManut.bairro"
              :disabled="editar"
            ></v-text-field>
          </v-col>
          <v-col xl="2" lg="2" md="2" cols="12">
            <v-text-field
              label="Cep"
              v-model="clienteManut.cep"
              :disabled="editar"
            ></v-text-field>
          </v-col>
          <v-col xl="4" lg="4" md="3" cols="12">
            <v-text-field
              label="Endereço complementar"
              v-model="clienteManut.endcomplementar"
              :disabled="editar"
            ></v-text-field>
          </v-col>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-text-field
              label="Latitude"
              v-model="clienteManut.latitude"
              :disabled="clienteManut.bloq_coordenadas"
            ></v-text-field>
          </v-col>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-text-field
              label="Longitude"
              v-model="clienteManut.longitude"
              :disabled="clienteManut.bloq_coordenadas"
            ></v-text-field>
          </v-col>
          <v-col xl="2" lg="2" md="3" cols="12" align-self="center">
            <btn-ver-localizacao :cliente="clienteManut">
              <v-icon size="17" class="mr-1">mdi-map-marker-outline</v-icon>
              Ver Localização
            </btn-ver-localizacao>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import CmbEstados from "../locais/CmbEstados.vue";
import CmbLocalidades from "../locais/CmbLocalidades.vue";
import CmbMunicipios from "../locais/CmbMunicipios.vue";
import BtnVerLocalizacao from "./BtnVerLocalizacao.vue";
export default {
  components: { CmbEstados, CmbMunicipios, CmbLocalidades, BtnVerLocalizacao },
  computed: {
    ...mapState("clientes", ["clienteManut", "editar"]),
    ...mapState("locais", ["municLoading", "estadoSelec", "localidLoading"]),
  },
  watch: {
    municLoading: function (isLoading) {
      if (!isLoading) {
        this.setMunicSelec(this.clienteManut.codmunicipio);
      }
    },
    localidLoading: function (isLoading) {
      if (!isLoading) {
        this.setLocalidSelec(this.clienteManut.codlocalidade);
      }
    },
  },
  data: () => ({}),
  methods: {
    ...mapMutations("locais", [
      "setEstadoSelec",
      "setMunicSelec",
      "setLocalidSelec",
    ]),
    ...mapActions("locais", ["getEstados", "getMunicipios"]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
  async mounted() {
    this.$store.commit("locais/resetState");
    await this.getEstados();
    this.setEstadoSelec(this.clienteManut.uf);
  },
};
</script>

<style>
</style>